module.exports = __webpack_public_path__ + "static/media/logo.b7658c26.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Login/logo.png
// module id = 1771
// module chunks = 0